import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import appStore from './modules/appStore'; // 공통 스토어

import dialogStore from './modules/dialogStore'; // 다이어로그 (지점 조회 페이지에서만 사용)

import userStore from './modules/userStore';
import bannerStore from './modules/bannerStore';
import signupStore from './modules/signupStore';
import findIdStore from './modules/findIdStore';
import findPasswordStore from './modules/findPasswordStore';
import userLeaveStore from './modules/userLeaveStore';
import reservationAppStore from './modules/reservationAppStore';
import reservationStore from './modules/reservationStore';

import shopStore from './modules/shopStore'; // 지점 조회
import contractStore from './modules/contractStore'; // 회원 계약 내역
import couponStore from './modules/couponStore'; // 회원 쿠폰함
import inquiryStore from './modules/inquiryStore'; // 회원 1:1문의

import asStore from './modules/asStore'; // 회원 관리 주기

export default new Vuex.Store({
	state: {},
	mutations: {},
	actions: {},
	modules: {
		appStore,
		dialogStore,
		bannerStore,
		userStore,
		signupStore,
		findIdStore,
		findPasswordStore,
		userLeaveStore,
		reservationAppStore,
		reservationStore,
		shopStore,
		contractStore,
		couponStore,
		inquiryStore,
		asStore,
	},
});
